import { Button } from '@chakra-ui/react'
import React, { useState } from 'react'

function Topics({ filterItems, topics }) {
  const [clicked, setClicked] = useState(false)

  //   const handleClick = (topic) => {
  //     if (clicked === false) {
  //       setClicked(true)
  //       return filterItems(['java'])
  //     } else {
  //       setClicked(false)
  //       return filterItems([''])
  //     }
  //   }

  return (
    <>
      {topics.map((topic, index) => (
        <Button key={index} onClick={filterItems(topic)}>
          {topic}
        </Button>
      ))}
    </>
  )
}

export default Topics
